import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useOutfitGeneratorStore = defineStore('outfitGenerator', () => {
  const exampleItems = ref([
    {
      id: 1,
      name: 'Item 1',
      image: 'https://via.placeholder.com/150',
    },
    {
      id: 2,
      name: 'Item 2',
      image: 'https://via.placeholder.com/150',
    },
    {
      id: 3,
      name: 'Item 3',
      image: 'https://via.placeholder.com/150',
    },
    {
      id: 4,
      name: 'Item 4',
      image: 'https://via.placeholder.com/150',
    },
    {
      id: 5,
      name: 'Item 5',
      image: 'https://via.placeholder.com/150',
    },
    {
      id: 6,
      name: 'Item 6',
      image: 'https://via.placeholder.com/150',
    },
    {
      id: 7,
      name: 'Item 7',
      image: 'https://via.placeholder.com/150',
    },
    {
      id: 8,
      name: 'Item 8',
      image: 'https://via.placeholder.com/150',
    },
    {
      id: 9,
      name: 'Item 9',
      image: 'https://via.placeholder.com/150',
    },
    {
      id: 10,
      name: 'Item 10',
      image: 'https://via.placeholder.com/150',
    }
  ])

  return {
    exampleItems
  }
})